import { useState } from "react";

export default function Section9() {
  const faqs = [
    {
      question: "How much do your SEO services cost?",
      answer:
        "Our pricing is customized based on your website’s size, industry competitiveness, and goals. We do not use cookie-cutter packages. Instead, we build a tailored SEO strategy to maximize your ROI. Book a free audit and we will provide a transparent proposal."
    },
    {
      question: "Do you work with all types of businesses?",
      answer:
        "Yes. We have experience with ecommerce brands, SaaS companies, healthcare, real estate, fintech, and local businesses. Whether you are a startup or an enterprise, our SEO strategies are designed to scale with your growth."
    },
    {
      question: "What makes Mean3 different from other SEO agencies?",
      answer:
        "Unlike agencies that only focus on keywords or backlinks, we combine technical SEO with content strategy and web development expertise. This allows us to not only rank your site higher but also improve conversions, speed, and user experience."
    },
    {
      question: "Can you help with local SEO?",
      answer:
        "Absolutely. At Mean3 we optimize Google Business Profiles, local citations, reviews, and geo-targeted content. This is especially powerful for service providers, retail, and multi-location businesses wanting to dominate their local markets."
    },
    {
      question: "How do you measure SEO success?",
      answer:
        "Success is measured through key metrics such as organic traffic, keyword rankings, lead generation, conversions, and ROI. We provide transparent monthly reports so you always know exactly how your investment is performing."
    },
    {
      question: "What platforms do you specialize in for SEO?",
      answer:
        "We work across Shopify, WooCommerce, Magento, WordPress, and custom-built websites. Our technical background ensures your platform is fully optimized for performance and search visibility."
    },
    {
      question: "How often will I receive updates or reports?",
      answer:
        "We provide detailed monthly reports covering rankings, traffic, conversions, and key wins. For ongoing projects, we also schedule strategy calls to review progress and align with your business goals."
    },
    {
      question: "Do you offer one-time SEO audits or only long-term retainers?",
      answer:
        "Both. Many clients start with a one-time technical SEO audit to identify issues and opportunities. From there, most choose ongoing monthly SEO to consistently grow traffic, leads, and revenue."
    }
  ];

  const [isOpen, setIsOpen] = useState(new Array(faqs.length).fill(false));

  const handleFaq = (index) => {
    setIsOpen((prevState) =>
      prevState.map((item, idx) => (idx === index ? !item : false))
    );
  };

  return (
    <div className="w-full Section9 mt-[8%] md:mt-[4%]">
      <div className="w-full section9-container">
        <div className="w-[90%] md:w-[61%] pb-[1%] mx-auto text-center">
          <h2 className="leading-[29px] md:leading-[41px] text-[24px] md:text-[34px] text-[#151515] font-bold my-[0.67em]">
            FAQs about SEO Services
          </h2>
        </div>

        <div className="w-full md:w-[784px] p-5 md:p-[2%] mx-auto faq-container font-open leading-[21px]">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="faq-item text-[11px] md:text-sm rounded-[8px] p-[2%] border border-solid border-[#DEDEDE] mb-[4%]"
              style={{
                background:
                  "linear-gradient(0deg, #FEFFFF, #FEFFFF), linear-gradient(0deg, #DEDEDE, #DEDEDE)",
              }}
            >
              <div
                onClick={() => handleFaq(index)}
                className="question text-[#444444] cursor-pointer flex justify-between items-center"
              >
                {faq.question}
                <b className="text-[40px] text-[#DA2128] font-[300]">
                  {isOpen[index] ? "-" : "+"}
                </b>
              </div>
              <div className={`${isOpen[index] ? "block" : "hidden"} answer text-[#444444]`}>
                <br />
                <p className="mb-5">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="line mb-[55px] md:mb-[4%] mt-[1%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
    </div>
  );
}
